const STEP_KEYS = {
	incomeStatement: 'incomeStatementTutorialStep',
	balanceSheet: 'balanceSheetTutorialStep',
	financialRatios: 'financialRatiosTutorialStep',
};

const FINANCIAL_RATIOS_TUTORIAL_KEYS = new Set([
	'RETURN_ON_ASSETS',
	'RETURN_ON_EQUITY',
	'GROSS_PROFIT_MARGIN',
	'NET_PROFIT_MARGIN',
	'ASSET_TURNOVER_RATIO',
	'INVENTORY_TURNOVER_RATIO',
]);

export function getTutorialStorageType(tutorialKey) {
	if (FINANCIAL_RATIOS_TUTORIAL_KEYS.has(tutorialKey)) return 'financialRatios';
	return null;
}

function prefixedKey(gameUserId, type) {
	return `${gameUserId}:${STEP_KEYS[type]}`;
}

export function getTutorialStep(gameUserId, type) {
	return localStorage.getItem(prefixedKey(gameUserId, type));
}

export function setTutorialStep(gameUserId, type, value) {
	localStorage.setItem(prefixedKey(gameUserId, type), value);
}

export function removeTutorialStep(gameUserId, type) {
	localStorage.removeItem(prefixedKey(gameUserId, type));
}
